import axios from 'axios';

const getUser = async (token) => {
  try {
    const response = await axios.get(
      'https://api.innofitness.ca/users/profile',
      {
        headers: {
          access: token,
        },
        withCredentials: true,
      }
    );
    if (response.status !== 200) {
      throw new Error(response.statusText);
    }
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      await logout();
      // .env
      // window.location.replace('http://localhost:3000/');
      window.location.replace('https://innofitness.ca/');
      return null;
    }
    const errorMsg = error.response?.data?.message;
    throw new Error(errorMsg || 'NETWORK_ERROR');
  }
};

const login = async () => {
  try {
    return await axios.get('https://api.innofitness.ca/login', {
      withCredentials: true,
    });
  } catch (error) {
    throw new Error(error.message);
  }
};

const logout = async (token) => {
  try {
    const response = await axios.post(
      'https://api.innofitness.ca/logout',
      null,
      {
        withCredentials: true,
      }
    );
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
    localStorage.clear();
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

const editProfile = async (formData, token) => {
  const url = 'https://api.innofitness.ca/users';
  try {
    const response = await axios.patch(url, formData, {
      headers: {
        'Content-Type': 'application/json',
        access: token,
      },
      withCredentials: true,
    });
    const data = response.json();
    if (response.status === 401) {
      await logout();
      // .env
      // window.location.replace('http://localhost:3000/');
      window.location.replace('https://innofitness.ca/');
      return null;
    }
    if (!response.ok) {
      const errorMsg = data?.message;
      throw new Error(errorMsg);
    }
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export default {
  getUser,
  login,
  logout,
  editProfile,
};
